/**
 * @file 解答実績 (学習者 × 資料の、問ごとの ○△×) のクライアント。
 * @what: `GET /families/{fid}/study/plans/{personId}/item_results/{sourceId}` と、1 回ぶんの記録
 *   `POST .../item_results/{sourceId}/items/{itemId}` (資料の全問の結果が返る)。
 * @why: 学習者のデータなので plan 配下。読み取り確認 (OCR が合っているか) とは別の軸。
 * @failure: ApiError を伝播。items が空 = まだ解いていない、は正常系。
 */

import { apiFetch } from "@/shared/api/client";

export type StudyItemResultKind = "ok" | "partial" | "ng";

export interface StudyItemAttempt {
  date: string;
  result: StudyItemResultKind;
}

export interface StudyItemResult {
  last: StudyItemAttempt;
  count: number;
  attempts?: StudyItemAttempt[];
}

/** 問 id → 結果。 */
export type StudyItemResults = Record<string, StudyItemResult>;

function path(familyId: string, personId: string, sourceId: string): string {
  return `/families/${encodeURIComponent(familyId)}/study/plans/${encodeURIComponent(
    personId,
  )}/item_results/${encodeURIComponent(sourceId)}`;
}

export async function fetchItemResults(
  familyId: string,
  personId: string,
  sourceId: string,
  signal?: AbortSignal,
): Promise<StudyItemResults> {
  const res = await apiFetch<{ items: StudyItemResults }>(
    path(familyId, personId, sourceId),
    signal ? { signal } : {},
  );
  return res.items;
}

export async function postItemResult(
  familyId: string,
  personId: string,
  sourceId: string,
  itemId: string,
  body: { result: StudyItemResultKind; date?: string },
): Promise<StudyItemResults> {
  const res = await apiFetch<{ items: StudyItemResults }>(
    `${path(familyId, personId, sourceId)}/items/${encodeURIComponent(itemId)}`,
    { method: "POST", body },
  );
  return res.items;
}
